import React, { useEffect, useState } from 'react';
import { AddGaragecategory, getSingleGarage, updateGarageCategory } from '../../actions/homeAction';
import { Link, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { addCategory } from '../../actions';
export default function AddGrageCategory() {
	const dispatch = useDispatch();
	const [AddCategory, setAddCategory] = useState({
		category: '',
		categoryEn: '',
		active: '',
		priority: 0,
	});
	const [dataEdit, setDataEdit] = useState(false)
	
	const {garageUUID} = useParams()

	const location = window.location.href.split('/')[5]
	useEffect(() => {
		if(location==="Update"){
			dispatch(getSingleGarage(garageUUID))
			setDataEdit(true)
		} else {
			setDataEdit(false)
		}
	},[])
	
	const singleGarage = useSelector(state => state.home.getSingleGarage)?.response

	console.log("garageUUIDgarageUUID", singleGarage);

	useEffect(() => {
		setAddCategory({
			category: singleGarage?.category,
			categoryEn: singleGarage?.categoryEn,
			active: singleGarage?.active,
			priority: singleGarage?.priority,
		})
	},[singleGarage])

	const handleChange = event => {
		const { name, value } = event.target;
		setAddCategory(user => ({ ...user, [name]: value }));
	};

	const onSave = () => {
		if(dataEdit){
			const payload = {
				categoryId: singleGarage?.categoryId,
				category:AddCategory.category,
				categoryEn:AddCategory.categoryEn,
				priority:AddCategory.priority,
				active:AddCategory.active
			}
			dispatch(updateGarageCategory(payload))
		} else {
			dispatch(AddGaragecategory(AddCategory));
		}
	};

	return (
		<>
			<div className=''>
				<div className='col-md-6'>
					<div className='form-group row'>
						<h1>Add Garage Category </h1>

						<div className='col-sm-9'></div>
					</div>
				</div>

				<div className='card-body'>
					<div className='row'>
						<div className='col-md-6'>
							<div className='form-group row'>
								<label className='col-sm-3 col-form-label'>
									Category (Arabic)
								</label>
								<div className='col-sm-9'>
									<input
										type='text'
										className='form-control'
										name='category'
										id='BusinessCategory'
										placeholder='Category (Arabic)'
										onChange={handleChange}
										value={AddCategory.category}
									/>
								</div>
							</div>
						</div>

						<div className='col-md-6'>
							<div className='form-group row'>
								<label className='col-sm-3 col-form-label'>
									Category (English)
								</label>
								<div className='col-sm-9'>
									<input
										type='text'
										className='form-control'
										name='categoryEn'
										id='BusinessCategoryEn'
										placeholder='Category (English)'
										onChange={handleChange}
										value={AddCategory.categoryEn}
									/>
								</div>
							</div>
						</div>

						<div className='col-md-6'>
							<div className='form-group row'>
								<label className='col-sm-3 col-form-label'>Priority</label>
								<div className='col-sm-9'>
									<input
										type='number'
										className='form-control'
										name='priority'
										id='Priority'
										placeholder='Priority'
										onChange={handleChange}
										value={AddCategory.priority}
									/>
								</div>
							</div>
						</div>

						<div className='col-md-6'>
							<div className='form-group row'>
								<label className='col-sm-3 col-form-label'>Status</label>
								<div className='col-sm-9'>
									<select
										name='active'
										className='form-control'
										value={AddCategory.active}
										onChange={handleChange}>
										<option>Select Status</option>
										<option value='true' name='active'>
											Active
										</option>
										<option value='false' name='inactive'>
											Inactive
										</option>
									</select>
								</div>
							</div>
						</div>
					</div>

					<div className='card-footer'>
						<div className='row float-right p-3'>
							<button onClick={onSave} className='btn btn-grd-disabled mr-2'>
								<i className='icofont icofont-save'></i> Save
							</button>
							<Link
								to={'/BusinessCategoryMaster/GarageCategory'}
								className='btn btn-outline-dark'>
								{' '}
								Cancel{' '}
							</Link>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
